import { HttpGet, HttpPost, HttpPostImage, HttpPut, HttpDelete } from "./Http"

export const setChangeStatus = async (id, payload) => {
    try {
        const data = await HttpPost(`admin/estado/${id}`, JSON.stringify(payload))
        return data;
    } catch (error) {
        return error
    }
}

export const getEstadosPublicaciones = async () => {
    try {
        const data = await HttpGet(`admin/publicaciones/estados`, false)
        return data;
    } catch (error) {
        return error
    }
}